//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CreateCdnResource from './components/createCdnResource.vue';
import { cdnResourceList } from '@/graphql/api/cdn_resource';
import dayjs from 'dayjs';
import { get } from 'lodash';
import { mapGetters } from 'vuex';

export default {
  components: { CreateCdnResource },
  data() {
    return {
      // 搜索表单
      searchForm: {
        name: '',
      },
      payload: {
        limit: 10,
        offset: 0,
      },
      page: 1,
      pageSize: 10,
      total: 0,
      // 表格
      loading: false,
      list: [],
      // 弹窗
      visible: false,
      editData: {},
      openType: 'create',
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']), // user 模块名称
    jurisdiction() {
      const jurisdictionArray = ['cdnResourceTools_upload'];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }
      return jurisdictionObj;
    },
  },
  async created() {
    this.getList();
  },
  methods: {
    dayjs,
    get,
    async getList() {
      this.loading = true;
      this.payload = {
        ...this.payload,
        limit: this.pageSize,
        offset: (this.page - 1) * this.pageSize,
      };
      try {
        const res = await cdnResourceList({
          name: this.payload.name ? `%${this.payload.name}%` : '%%',
          limit: this.payload.limit,
          offset: this.payload.offset,
        });
        const data = res.cdn_resource;
        this.list = data?._data;
        console.log('cdn resource list: ', this.list);
        this.total = parseInt(data?._aggregate?.count || 0);
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.list = [];
        this.loading = false;
      }
    },
    onAdd() {
      this.editData = {};
      this.openType = 'create';
      this.visible = true;
    },
    // 翻页器
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getList();
    },
    searchList() {
      this.page = 1;
      this.payload.name = this.searchForm.name || '';
      this.getList();
    },
    resetForm() {
      this.searchForm.name = '';
      delete this.payload.name;
      this.getList();
    },
    onCopy(row) {
      navigator.clipboard
        .writeText(row.cdn_url)
        .then(() => {
          this.$message.success('复制成功');
        })
        .catch((err) => {
          this.$message.error('Failed to copy text: ', err);
        });
    },
    isImg(url) {
      const extension = url.split('.').pop().toLowerCase();
      return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'].includes(extension);
    },
  },
};
